import { Injectable } from '@angular/core';
import { Subject, timer, Subscription } from 'rxjs';
import { Service as ServiceStorage } from '@services/storage.service';

@Injectable({ providedIn: 'root' })
export class Service {

    private time: number = 900000;
    private storage_key = 'ticket_support_timer';
    private TimerSubscription: Subscription | null = null;
    private intervalRef: any = null;
    private AutoCloseSubject = new Subject<any>();
    private CountdownSubject = new Subject<{ display: string, item_id: number } | null>();
    countdown$ = this.CountdownSubject.asObservable();
    autoClose$ = this.AutoCloseSubject.asObservable();

    constructor(
        private ServiceStorage: ServiceStorage
    ) { }

    async startTimer(data: any) {
        if (!data?.item_id || !data?.start_time) return;

        this.clearTimer();

        await this.ServiceStorage.set(this.storage_key, JSON.stringify(data));

        const target = data.start_time + this.time;

        const update = () => { 
            const now = Date.now();const remaining = target - now;

            if (remaining <= 0) {
                this.CountdownSubject.next(null);
                this.AutoCloseSubject.next(data);
                this.clearTimer();
                return;
            }

            const seconds = Math.floor(remaining / 1000);
            const minutes = Math.floor(seconds / 60);
            const secs = seconds % 60;
            const display = String(minutes).padStart(2, '0') + ':' + String(secs).padStart(2, '0');

            this.CountdownSubject.next({ display, item_id: data.item_id });
        };

        update();
        this.intervalRef = setInterval(update, 1000);
        const remaining = target - Date.now();
        this.TimerSubscription = timer(remaining).subscribe(() => {this.CountdownSubject.next(null); this.AutoCloseSubject.next(data);this.clearTimer();});
    }

    clearTimer() {
        if (this.TimerSubscription) {
            this.TimerSubscription.unsubscribe();
            this.TimerSubscription = null;
        }

        if (this.intervalRef) {
            clearInterval(this.intervalRef);
            this.intervalRef = null;
        }

        this.CountdownSubject.next(null);
        this.clearStorage();
    }

    async restoreTimer() {
        const data = await this.ServiceStorage.get(this.storage_key);
        if (!data) return;

        try {
            const parsed = JSON.parse(data);
            const elapsed = Date.now() - parsed.start_time;
            const remaining = this.time - elapsed;

            if (remaining <= 0) {
                this.AutoCloseSubject.next({ item_id: parsed.item_id });
                this.clearStorage();
                return;
            }

            this.startTimer({item_id: parsed.item_id,start_time: parsed.start_time});

        } catch (error: any) {
            console.error('Error restoring timer', error);
            this.clearStorage();
        }
    }

    private async clearStorage() {
        await this.ServiceStorage.remove(this.storage_key);
    }
}